import React, { useState, useEffect } from 'react';
import '../../assets/styles/popup.css';

interface PopupProps {
  isOpen: boolean;
  onClose?: () => void;
  title?: string;
  message?: string;
  iconSrc?: string;
  iconAlt?: string;
  showCloseButton?: boolean;
  children?: React.ReactNode;
  customClassName?: string;
  overlayClassName?: string;
  titleClassName?: string;
}

const Popup: React.FC<PopupProps> = ({
  isOpen,
  onClose,
  title,
  message,
  iconSrc = "/images/grey-cancel-cta.png",
  iconAlt = "",
  showCloseButton = true,
  children,
  customClassName = "",
  overlayClassName = "",
  titleClassName = "",
}: PopupProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    } else {
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!isVisible && !isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose?.();
    }
  };

  return (
    <div
      className={`download-popup-overlay ${overlayClassName} ${isOpen ? 'open' : 'closing'}`}
      onClick={handleOverlayClick}
    >
      <div className={`download-popup ${customClassName}`}>
        {showCloseButton && (
          <div className="d-flex flex-row justify-content-end">
            <div className="page-icon" onClick={onClose}>
              <img
                src="/images/close-inactive.png"
                alt="close"
                className="icon-normal"
              />
              <img
                src="/images/close-active.png"
                alt="close"
                className="icon-hover"
              />
            </div>
          </div>
        )}

        <div className="popup-content">
          {/* <div className="popup-icon error">
            ✕
          </div> */}
          {/* <h1 style={{color:"#0d2f6f"}}>:(</h1> */}
          <h5 style={{ color: "red" }}>Ooops!</h5>

          {title && (
            <div className={`popup-title-modern ${titleClassName}`}>
              {title}
            </div>
          )}

          {message && (
            <p className="popup-message-modern">
              {message}
            </p>
          )}

          {children ?? (
            <button className="popup-primary-btn mt-3" onClick={onClose}>
               Close
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Popup;